import React, {Component} from 'react';

export const ErrorBoundary = class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {errorMessage: null};
	}

	static getDerivedStateFromError(error, errorInfo) {
		// Update state so the next render will show the fallback UI.
		return {errorMessage: '' + error};
	}

	componentDidCatch(error, errorInfo) {
		typeof this.props.onDidCatch === 'function' && this.props.onDidCatch(error, errorInfo);
	}

	render() {
		if (this.state.errorMessage) {
			// You can render any custom fallback UI
			return this.props.renderError(this.state.errorMessage);
		}

		return this.props.children;
	}
};
